import axios from 'axios';

export default {
    namespaced: true,
    state: {
        threads: null,
        rentals: null,
        listings: null
    },
    mutations: {
        setThreads(state, threads) {
            state.threads = threads;
        },
        setRentals(state, rentals) {
            state.rentals = rentals;
        },
        setListings(state, listings) {
            state.listings = listings;
        }
    },
    actions: {
        getThreads({ commit }) {
            commit('setThreads', null);
            return axios
                .get('/messages/get-threads', { params: { top: 3 } })
                .then(result => commit('setThreads', result.data.data))
                .catch(console.error);
        },
        getUpcomingRentals({ commit }) {
            commit('setRentals', null);
            axios
                .get('/upcoming-rentals', { params: { hasLimit: true } })
                .then(result => commit('setRentals', result.data.data))
                .catch(console.error);
        },
        getActiveListings({ commit }) {
            commit('setListings', null);
            axios
                .get('/active-listings', { params: { hasLimit: true } })
                .then(result => commit('setListings', result.data.data))
                .catch(console.error);
        }
    }
};
